import { Card, CardTitle, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ProductMetricsSkeleton = () => {
  return (
    <>
      <Card showBorder={false}>
        <CardTitle>
          <Skeleton variant="text" width={180} height={24} />
        </CardTitle>
        <Styles.RowsContainer>
          <Skeleton variant="rounded" width="100%" height={48} />
          <Skeleton variant="rounded" width="100%" height={48} />
        </Styles.RowsContainer>
      </Card>
      <Card showBorder={false}>
        <CardTitle>
          <Skeleton variant="text" width={220} height={24} />
        </CardTitle>
        <Styles.ChartContainer>
          <Styles.ChipsRow>
            <Skeleton variant="rounded" width={120} height={28} />
            <Skeleton variant="rounded" width={120} height={28} />
            <Skeleton variant="rounded" width={120} height={28} />
          </Styles.ChipsRow>
          <Skeleton variant="rounded" width="100%" height={280} />
        </Styles.ChartContainer>
      </Card>
      <Card showBorder={false}>
        <CardTitle>
          <Skeleton variant="text" width={260} height={24} />
        </CardTitle>
        <Styles.ChartContainer>
          <Styles.ChipsRow>
            <Skeleton variant="rounded" width={120} height={28} />
            <Skeleton variant="rounded" width={120} height={28} />
          </Styles.ChipsRow>
          <Skeleton variant="rounded" width="100%" height={280} />
        </Styles.ChartContainer>
      </Card>
      <Card showBorder={false}>
        <CardTitle>
          <Skeleton variant="text" width={160} height={24} />
        </CardTitle>
        <Styles.RowsContainer>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.RowsContainer>
      </Card>
      <Styles.ColumnsContainer>
        <Card showBorder={false}>
          <CardTitle>
            <Skeleton variant="text" width={180} height={24} />
          </CardTitle>
          <Styles.RowsContainer>
            <Skeleton variant="rounded" width="100%" height={32} />
            <Skeleton variant="rounded" width="100%" height={32} />
            <Skeleton variant="rounded" width="100%" height={32} />
          </Styles.RowsContainer>
        </Card>
        <Card showBorder={false}>
          <CardTitle>
            <Skeleton variant="text" width={180} height={24} />
          </CardTitle>
          <Styles.RowsContainer>
            <Skeleton variant="rounded" width="100%" height={32} />
            <Skeleton variant="rounded" width="100%" height={32} />
            <Skeleton variant="rounded" width="100%" height={32} />
          </Styles.RowsContainer>
        </Card>
      </Styles.ColumnsContainer>
    </>
  )
}

export default ProductMetricsSkeleton
